import { Reveal } from "./motion";

export const WhyThursdays = () => (
  <section id="thursdays" data-testid="thursdays" className="bg-ink text-oat px-5 sm:px-8 lg:px-12 py-24 sm:py-32">
    <div className="max-w-[1100px] mx-auto">
      <Reveal>
        <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.24em] text-sunbeam">
          why thursdays
        </span>
        <h2 className="mt-4 font-display font-black lowercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-7xl">
          grow what is<br />uniquely yours
        </h2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14">
        <Reveal delay={0.12}>
          <p className="text-lg sm:text-2xl font-medium leading-[1.2] text-oat/85">
            this is dedicated space to make, experiment, follow your curiosity, share ideas, be
            supported, and let proximity to other creative people expand what feels possible.
            there's a collective shift happening right now, away from the lone star and toward
            community, innovation, and the collective.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-lg sm:text-2xl font-medium leading-[1.2] text-oat/85">
            traditionally, thursday belongs to jupiter: growth, abundance, faith, generosity,
            wisdom, opportunity, teaching, big-picture thinking. but jupiter is currently traveling
            through leo. so right now jupiter isn't saying simply grow. it's saying{" "}
            <span className="text-sunbeam italic font-display font-semibold">grow what is uniquely yours.</span>
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
